export interface User {
  id?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  groupId?: string;
  groupName?: string;
  groupCountryId?: string;
  groupCountryCode?: string;
  headquarterId?: string;
  headquarterName?: string;
  role?: UserRole;
  isStreaming?: boolean;
  preferredLanguage?: string;
}

export enum UserRole {
  Admin = "admin",
  HeadquarterAdmin = "headquarterAdmin",
  GroupAdmin = "groupAdmin",
  User = "user",
  Guest = "guest",
}
